import styled from "styled-components";

export const SwitchTenantWrapper = styled.div`
    padding: 0 5px;
    .custom-display-value {
        white-space: nowrap;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        color: rgb(255, 255, 255);
        padding-right: 10px;
        padding-left: 5px;
    }

    .custom-input {
        display: flex;
        font-size: 14px;
        font-weight: 400;
        box-shadow: none;
        padding: 0px 8px;
        box-sizing: border-box;
        border-radius: 0px;
        text-overflow: ellipsis;
        outline: 0px;
        height: 32px;
        align-items: center;
    }

    .custom-icon {
        color: rgb(255, 255, 255);
    }

    .icon-chevron-down {
        color: rgb(255, 255, 255);
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .custom-icon-small {
        color: rgb(255, 255, 255);
    }

    .mt-2 {
        margin-top: 2px;
    }

    .border-dark {
        border: 1px solid rgb(255, 255, 255);
    }

    .border-light {
        border: 1px solid rgb(166, 166, 166);
    }

    .custom-display-value {
        white-space: nowrap;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .custom-icon-small {
        color: rgb(255, 255, 255);
    }

    .color-placeholder-light {
        color: #605e5c;
    }

    .color-placeholder-dark {
        color: rgb(255, 255, 255) !important;
        opacity: 0.6;
    }

    .mb-5 {
        margin-bottom: 5px;
    }

    .is_disabled {
        opacity: 0.4;
    }

    .icon-dropdown-light {
        color: rgb(102, 102, 102);
        font-size: 12px;
    }

    .icon-dropdown-dark {
        color: rgb(255, 255, 255);
        font-size: 12px;
    }

    .color-dark {
        color: rgb(255, 255, 255);
    }

    .listEmptyWrapper {
        display: flex;
        justify-content: center;
    }
`